import { getAllData } from 'apis/customApiHandler';
import useDebounce from 'hooks/useDebounce';
import { Fragment, useCallback, useState } from "react";
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import ReactSelect from "react-select";
import { filterSelectStyles } from "utils/reactSelectStyles";
import { Button, Input } from 'styled';
import { TH } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import permissions from 'utils/permissionConstants';
import Add from './Add';
import ViewList from './ViewList';
import Spinner from 'components/Spinner';

const Index = () => {
  const [showAddmodel, setShowAddmodel] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedMakes, setSelectedMakes] = useState([]);
  const [selectedModels, setSelectedModels] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const debouncedValue = useDebounce(search, 1000);
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const getData = async ()=>{
    setIsLoading(true)
    try{
    const dt = await getAllData('/vehicle-configuration-master', {
      ...(selectedMakes.length && {
        makes: selectedMakes.map((make) => make).join(","),
      }),
      ...(selectedModels.length && {
        models: selectedModels.map((model) => model).join(","),
      }),
      searchQuery: debouncedValue,
      limit: 2000,
      page: 1,
    })
    // console.log(dt)
    setData(dt);
  }catch(err){

  }finally{
    setIsLoading(false)
  }
  }

  const { data: allMakes } = useQuery([`/vehicle-make-master`], () =>
    getAllData("/vehicle-make-master", {
      limit: 250,
      page: 1,
    })
  );
  const { data: allModels } = useQuery([`/vehicle-model-master`], () =>
    getAllData("/vehicle-model-master", {
      limit: 250,
      page: 1,
    })
  );

  const getMakeOptions = useCallback(() => {
    if (allMakes && allMakes.data && allMakes.data.length) {
      return [
        {
          label: "Select All",
          value: "all",
        },
        ...allMakes?.data?.map((mk) => {
          return {
            value: mk._id,
            label: mk.makeName,
          };
        }),
      ];
    }
  }, [allMakes]);

  const getModelOptions = useCallback(() => {
    if (allModels && allModels.data && allModels.data.length) {
      return [
        selectedMakes?.length && {
          label: "Select All",
          value: "all",
        },
        ...(allModels?.data?.length &&
          allModels?.data
            ?.filter((model) => {
              // const selectedMakesData = allMakes?.data?.filter((make) =>
              //   selectedMakes?.includes(make._id)
              // );

              return selectedMakes?.some(
                (mk) => mk === model.make._id
              );
            })
            ?.map((model) => {
              return {
                value: model._id,
                label: model.name,
              };
            })),
      ];
    }
  }, [allMakes, allModels, selectedMakes]);

  return (
    <div>
      <div className="m-10">
        <div className="mt-8 flex justify-start items-end gap-4 flex-wrap lg:flex-nowrap">
            <label className="w-full py-3 flex flex-col gap-2">
              Search
              <Input
              type="search"
              placeholder="Search Here"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") getData();
              }}
            />
            </label>
            <label className="w-full py-3 flex flex-col gap-2">
            Select Makes
            <ReactSelect
              styles={filterSelectStyles}
              className="shadow-md rounded-md"
              options={getMakeOptions()}
              value={
                selectedMakes &&
                selectedMakes?.map((make) => {
                  return {
                    value: make,
                    label: allMakes?.data?.find((item) => item?._id === make)
                      ?.makeName,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);

                if (allValues.includes("all")) {
                  setSelectedMakes(
                    allMakes?.data?.map((item) => {
                      return item._id;
                    })
                  );
                } else {
                  let selectedMakesVal = allMakes?.data?.filter((fleet) =>
                    value?.map((item) => item.value)?.includes(fleet._id)
                  );

                  let selectedModelsVal = allModels?.data?.filter((hub) =>
                    selectedModels?.map((item) => item)?.includes(hub._id)
                  );

                  setSelectedModels(
                    selectedModelsVal
                      ?.filter((model) =>
                        selectedMakesVal?.find(
                          (make) => make.makeName === model.makeName
                        )
                      )
                      .map((model) => model._id)
                  );

                  setSelectedMakes(value.map((make) => make.value));
                }
              }}
              name="fleets"
              isMulti={true}
            />
          </label>

          <label className="w-full py-3 flex flex-col gap-2">
            Select Models
            <ReactSelect
              styles={filterSelectStyles}
              className="shadow-md rounded-md"
              options={getModelOptions()}
              value={
                selectedModels &&
                selectedModels?.map((model) => {
                  // console.log( allModels?.data?.find((item) => item._id === model))
                  return {
                    value: model,
                    label: allModels?.data?.find((item) => item._id === model)
                      ?.name,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);
                console.log({value})
                // console.log({allMakes, allModels})
                if (allValues.includes("all")) {
                  setSelectedModels((pre) =>
                    allModels?.data
                      ?.filter((model) => {
                        const selectedMakesVal = allMakes?.data?.filter(
                          (make) => selectedMakes?.includes(make._id)
                        );
                        console.log({selectedMakesVal})
                        return selectedMakesVal?.some(
                          (make) => make.makeName === model.make.makeName
                        );
                      })
                      ?.map((model) => model._id)
                  );
                } else {
                  setSelectedModels(value.map((model) => model.value));
                }
              }}
              name="hubs"
              isMulti={true}
            />
          </label>
            <Button
              className="mb-3 !px-8 disabled:bg-gray-400"
              onClick={() => getData()}
              bgPrimary
              // disabled={
              //   false
              //   // !checkPermission([permissions.manage_masters], currentUser)
              // }
            >
            Search
          </Button>
          <Button
            className="mb-3 !px-8 disabled:bg-gray-400"
            onClick={() => setShowAddmodel(true)}
            bgPrimary
            disabled={
              !checkPermission([permissions.manage_masters], currentUser)
            }
          >
            Add
          </Button>
        </div>
      </div>
      <div className="flex flex-col m-2 lg:m-10">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <TH scope="col">S.N.</TH>
                    <TH scope="col">Make</TH>
                    <TH scope="col">Model</TH>
                    <TH scope="col">Configuration</TH>
                    <TH scope="col">Vehicle Configuration (TREEL)</TH>
                    <TH scope="col">Wheels</TH>
                    <TH scope="col">Tyre Positions</TH>
                    {/* <TH scope="col">Agreement</TH> */}
                    <TH scope="col">Created At</TH>
                    <TH scope="col">Actions</TH>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {!isLoading ? data?.data &&
                    data?.data.map((d, index) => {
                      console.log("DATAA", d);
                      return (
                      <ViewList data={d} key={d._id.toString()} index={index} getData={getData}/>
                    )}): <Spinner/>}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {showAddmodel && <Add handleClick={() => setShowAddmodel(false)} />}
    </div>
  );
};

export default Index;
